import { Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import { weekDays } from '../../../../app/common/util/util';
import { RouteTime } from '../../../../app/models/form';
import MySelectInput from '../../../../app/common/form/MySelectInput';

interface Props {
    values: any,
    getAmTimeByDay: (day: number) => RouteTime,
    handleChange: (name: string|any, value: string|object) => void
}

export default observer(function MorningTimeSelectInputs2({ 
    values,
    getAmTimeByDay,
    handleChange
 }: Props) {
    return (
        <>
            {weekDays.map((x, i) => {
                return(
                    <Fragment key={`am2Time${i+i}`}>
                        <label>{x}</label>
                        <MySelectInput 
                            options={getAmTimeByDay(i+1)} 
                            placeholder='Not Sailing'
                            name={`am2Time${i+1}`}
                            defaultValue={values[`am2Time${i+1}`]}
                            onChange={(data: string) => {
                                handleChange(`am2Time${i+1}`, data);
                            }}
                        />
                    </Fragment>
                )
            })}
        </>
    )
})